import React, { Component } from 'react';
import { getBinInfo, registerAttempt } from '../../../netoworking/CheckoutDebtCollectionNetwork'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

const $ = window.$;
export class TdsGetnet extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      loading: true,
      cardOnlyNumbers: '',
      expirationMonth: '',
      expirationYear: '',
      cardType: '',
      address: {
        country: '',
        regionCode: '',
        city: '',
        postal: ''
      },
      additionalObject: {
        ipAddress: null,
        linkGuid: null
      },
      requestBinInfo: false,
      personalId: '',
      personalType: '',
      urlBase: window.location.protocol + "//" + window.location.host,
      isProduction: window.location.host.toString().includes('pagamentos.cappta'),
      showBankAuthorizationModal: false,
      showTtdsTimeoutModal: false
    }
  }

  async componentDidMount() {
    //this.getAddress()  
  }

  componentDidUpdate = async (prevProps) => {

    if (this.state.personalId != this.props?.checkoutConfig?.document
      && this.props?.checkoutConfig?.document) {
      let document = this.props?.checkoutConfig?.document ?? ''
      let documentType = document.length == 11 ? 'CPF' : 'CNPJ'
      this.setState(prevState => ({
        ...prevState,
        personalId: document,
        personalType: documentType
      }))
    }

    const card = this.props.card

    let monthAndYear = card.expirationDate.replace(/[^\d.,]/g, '')
    if (card.validField.validExpirationDate == 'is-valid'
      && monthAndYear.length == 4
      && this.state.expirationYear == '') {
      let expirationDate = card.expirationDate.split('/')
      let expirationMonth = expirationDate[0]
      let expirationYear = '20' + expirationDate[1]

      this.setState(prevState => ({
        ...prevState,
        expirationMonth,
        expirationYear
      }
      ))
    }

    if (prevProps.requestBinInfo != this.props.requestBinInfo
        && this.props.requestBinInfo == true) {
        const linkGuid = this.props?.linkGuid
        await registerAttempt(linkGuid)

      try {
        let cardOnlyNumbers = card.number.replace(/[^\d.,]/g, '')
        //let cardTokenResponse = await getCardToken(cardOnlyNumbers)
        let binInfo = await getBinInfo(cardOnlyNumbers)

        if (binInfo && binInfo.isSuccess) {
          this.setState(prevState => ({
            ...prevState,
            cardType: binInfo.cardType,
            //cardOnlyNumbers: cardTokenResponse.numberToken,
            cardOnlyNumbers,
            additionalObject: {
              ...prevState.additionalObject,
              linkGuid: this.props.linkGuid,
              quotationId: this.props.quotationId.toString(),
              isWhiteLabel: this.props?.checkoutConfig?.isWhiteLabel
            }
          }
          ), () => {
            window.GN3DS.init(this.handle3DSGetnetInit)
          })
        }
      } catch {
        this.setState(prevState => ({
          ...prevState,
          cardOnlyNumbers: 'Error'
        }))
      }
    }
  }

  getAddress = async () => {
    try {
      const response = await fetch('https://ipapi.co/json');
      if (!response.ok) {
        throw new Error('Erro ao buscar o IP');
      }
      const data = await response.json();
      this.setState(prevState => ({
        additionalObject: {
          ...prevState.additionalObject,
          ipAddress: data.ip
        },
        address: {
          country: data.country,
          regionCode: data.region_code,
          city: data.city,
          postal: data.postal
        },
        loading: false,
      }));
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false,
      });
    }
  };

  handle3DSGetnetInit = (response) => {
    if (response != null && response.status >= 200 && response.status <= 299) {
      window.response_global = response
      try {
        this.handleTimeToAuthenticate(90)
        // Show bank authorization modal
        this.showBankAuthorizationModal()
        window.GN3DS.authentication(this.handle3DSGetnetAuthentication)
      } catch (e) {
        console.debug(e)
        this.hideBankAuthorizationModal()
        this.props.handleSettlementError("Não foi possível autenticar no servidor 3DS.");
        this.props.releaseRequestBinInfo()
      }
    } else {
      this.props.handleSettlementError("Erro ao inciar o processo");
      this.props.releaseRequestBinInfo()
    }
  }

  handleTimeToAuthenticate = (timeToAuthenticateInSeconds) => {
    window.timeController = { startedAt: new Date(), durationInSeconds: timeToAuthenticateInSeconds, intervalId: null, isExpired: false }
    window.timeController.intervalId = setInterval(() => {
      const dataStart = window.timeController.startedAt;
      const now = new Date();
      const diffInSeconds = (now - dataStart) / 1000;

      if (diffInSeconds >= window.timeController.durationInSeconds) {
        console.log(`timeout cancel attempt`);
        clearInterval(window.timeController.intervalId);
        window.timeController.isExpired = true
        this.showTdsTimeoutModal()
        this.props.releaseRequestBinInfo()
      } else {
        console.log(`time in seconds: ${diffInSeconds}`);
      }
    }, 1000)
  }

  clearTimeToAuthenticate = () => {
    const isExpired = window?.timeController?.isExpired

    if (window?.timeController) {
      clearInterval(window.timeController.intervalId)
      window.timeController = null
    }
    return isExpired
  }

  handle3DSGetnetAuthentication = (response) => {
    if (this.clearTimeToAuthenticate()) { return }

    if (window.response_global == null) {
      this.hideBankAuthorizationModal()
      this.props.handleSettlementError("Erro ao inciar o processo")
      return
    }

    if (response != null && response.status >= 200 && response.status <= 299) {
      window.response_global2 = response
      let authenticationData = response.data[0]
      let consumerAuthInfo = response.data[0].consumerAuthenticationInformation
      let errorInformation = response.data[0].errorInformation

      if (consumerAuthInfo.paresStatus === 'N') {
        this.hideBankAuthorizationModal()
        this.props.handleSettlementError("Falha na autenticação do usuário.")
        this.props.releaseRequestBinInfo()
      } else if (consumerAuthInfo.veresEnrolled === 'Y' && consumerAuthInfo.paresStatus === 'R') {
        this.hideBankAuthorizationModal()
        this.props.handleSettlementError("Não foi possível autenticar o 3DS com o emissor do cartão. Entre em contato com o emissor do seu cartão.")
        this.props.releaseRequestBinInfo()
      } else if (authenticationData.status === 'AUTHENTICATION_SUCCESSFUL'
        && (consumerAuthInfo.veresEnrolled === undefined || consumerAuthInfo.veresEnrolled === 'Y')
        && (consumerAuthInfo.eci === '02' || consumerAuthInfo.eci === '05')
        && (consumerAuthInfo.paresStatus === 'C' || consumerAuthInfo.paresStatus === 'Y')) {
        let threeDsGetnet = {
          xid: consumerAuthInfo?.xid,
          ucaf: consumerAuthInfo.ucaf,
          eci: consumerAuthInfo.eci,
          tdsdsxid: consumerAuthInfo.directoryServerTransactionId,
          tdsver: consumerAuthInfo.specificationVersion,
          paresStatus: consumerAuthInfo.paresStatus,
          status: authenticationData.status
        }
        this.hideBankAuthorizationModal()
        this.props.onClickDoPaymentThreeDsGetnet(threeDsGetnet)
      } else {
        this.hideBankAuthorizationModal()
        if (errorInformation?.reason) {
          this.props.handleSettlementError(`motivo: ${errorInformation.reason} mensagem: ${errorInformation.message}`)
        }
        this.props.handleSettlementError("Não foi possível fazer a autenticação 3ds")
        this.props.releaseRequestBinInfo()
      }
    } else {
      this.hideBankAuthorizationModal()
      this.props.handleSettlementError("Erro ao inciar a autenticação 3ds2.1")
      this.props.releaseRequestBinInfo()
    }
  }

  getPhoneNumber = () => {
    let card = this.props.card
    if (card.validField.validHolderPhoneNumber == 'is-valid') {
      return card.holderPhoneNumber.replace(/[^\d.,]/g, '')
    }

    return ''
  }

  getMail = () => {
    let card = this.props.card
    if (card.holderEmail.trim() != '') {
      return card.holderEmail
    }

    return 'fake@mail.com'
  }

  getFirstName = () => {
    let card = this.props.card
    if (card.validField.validHolderName == 'is-valid') {
      let fullName = card.holderName.split(' ')
      let firstName = fullName[0] ?? ''
      let lastName = fullName[fullName.length - 1] ?? ''

      return firstName
    }

    return ''
  }

  getLastName = () => {
    let card = this.props.card
    if (card.validField.validHolderName == 'is-valid') {
      let fullName = card.holderName.split(' ')
      let firstName = fullName[0] ?? ''
      let lastName = fullName[fullName.length - 1] ?? ''

      return lastName
    }

    return ''
  }

  getZipCode = () => {
    let zipCode = this.props.card.zipCode
    if (zipCode) {
      return zipCode.replace(/[^\d]/g, '')
    }
    return ''
  }

  isMobileDevice = () => {
    if ('userAgentData' in window.navigator && 'mobile' in window.navigator.userAgentData) {
      return window.navigator.userAgentData.mobile;
    }
    if ('maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints > 0) {
      return true;
    }
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
  }

  showBankAuthorizationModal = () => {
    this.setState({ showBankAuthorizationModal: true });
    $('#bankAuthorizationModal').modal('show');
    
    // Auto-hide modal after 4 seconds
    setTimeout(() => {
      this.hideBankAuthorizationModal();
    }, 4000);
  }

  hideBankAuthorizationModal = () => {
    this.setState({ showBankAuthorizationModal: false });
    $('#bankAuthorizationModal').modal('hide');
  }

  showTdsTimeoutModal = () => {
    this.setState({ showTtdsTimeoutModal: true });
    $('#tdsTimeoutModal').modal('show');
  }

  hideTdsTimeoutModal = () => {
    this.setState({ showTtdsTimeoutModal: false });
    $('#tdsTimeoutModal').modal('hide');
  }

  render() {
    return (
      <>
        <div className='gn3ds_config'>
          <input type='hidden' id='gn3ds_merchantBackEndUrl' name='gn3ds_merchantBackEndUrl' className='gn3ds_environment_' value={this.state.urlBase + '/3ds/getnet/'} />
          <input type='hidden' id='gn3ds_merchantBackEndTokenBasic' name='gn3ds_merchantBackEndTokenBasic' className='gn3ds_environment_' value='' />
          <input type='hidden' id='gn3ds_merchantBackEndTokenOauth' name='gn3ds_merchantBackEndTokenOauth' className='gn3ds_environment_' value='' />
          <input type='hidden' id='gn3ds_environment' name='gn3ds_environment' className='gn3ds_environment_' value={this.state.isProduction ? 'PRD' : 'SDB'} />
          <input type='hidden' id='gn3ds_debug' name='gn3ds_debug' className='gn3ds_environment_' value={this.state.isProduction ? 'false' : 'true'}/>
          <input type='hidden' id='gn3ds_debugPrefix' name='gn3ds_debugPrefix' className='gn3ds_environment_' value='[GN3DS]' />
          <input type='hidden' id='gn3ds_frameworkModal' name='gn3ds_frameworkModal' className='gn3ds_environment_' value='default' />
          <input type='hidden' id='gn3ds_newApiVersion' name='gn3ds_newApiVersion' className='gn3ds_environment_' value='true' />
        </div>
        <div className='gn3ds_creditCardData'>
          <input type='hidden' id='gn3ds_cardType' name='gn3ds_cardType' className='gn3ds_checkout_' value={this.state.cardType} />
          <input type='hidden' id='gn3ds_cardExpirationMonth' name='gn3ds_cardExpirationMonth' className='gn3ds_checkout_' value={this.state.expirationMonth} />
          <input type='hidden' id='gn3ds_cardExpirationYear' name='gn3ds_cardExpirationYear' className='gn3ds_checkout_' value={this.state.expirationYear} />
          <input type='hidden' id='gn3ds_cardNumber' name='gn3ds_cardNumber' className='gn3ds_checkout_' value={this.state.cardOnlyNumbers} />
          {/* 02: Crédito 03: Débito */}
          <input type='hidden' id='gn3ds_overridePaymentMethod' name='gn3ds_overridePaymentMethod' className='gn3ds_checkout_' value='02' />
          <input type='hidden' id='gn3ds_cardHolderName' name='gn3ds_cardHolderName' className='gn3ds_checkout_' value={this.props.card.holderName} />
          <input type='hidden' id='gn3ds_installmentTotalCount' name='gn3ds_installmentTotalCount' className='gn3ds_checkout_' value={this.props.installments} />
          <input type='hidden' id='gn3ds_additionalData' name='gn3ds_additionalData' className='gn3ds_checkout_' value='' />
          <input type='hidden' id='gn3ds_additionalObject' name='gn3ds_additionalObject' className='gn3ds_checkout_' value={JSON.stringify(this.state.additionalObject)} />
        </div>
        <div className='gn3ds_ShipTo'>
          <input type='hidden' id='gn3ds_shipToFirstName' name='gn3ds_shipToFirstName' className='gn3ds_checkout_' value={this.getFirstName()} />
          <input type='hidden' id='gn3ds_shipToLastName' name='gn3ds_shipToLastName' className='gn3ds_checkout_' value={this.getLastName()} />
          <input type='hidden' id='gn3ds_shipToAddress1' name='gn3ds_shipToAddress1' className='gn3ds_checkout_' value={this.props.card.address} />
          <input type='hidden' id='gn3ds_shipToAddress2' name='gn3ds_shipToAddress2' className='gn3ds_checkout_' value={this.props.card.complement} />
          <input type='hidden' id='gn3ds_shipToAdministrativeArea' name='gn3ds_shipToAdministrativeArea' className='gn3ds_checkout_' value={this.props.card.state} />
          <input type='hidden' id='gn3ds_shipToCountry' name='gn3ds_shipToCountry' className='gn3ds_checkout_' value='BR' />
          <input type='hidden' id='gn3ds_shipToLocality' name='gn3ds_shipToLocality' className='gn3ds_checkout_' value={this.props.card.city} />
          <input type='hidden' id='gn3ds_shipToPostalCode' name='gn3ds_shipToPostalCode' className='gn3ds_checkout_' value={this.getZipCode()} />
          <input type='hidden' id='gn3ds_shipToDestinationCode' name='gn3ds_shipToDestinationCode' className='gn3ds_checkout_' value='05' />
          <input type='hidden' id='gn3ds_shipToMethod' name='gn3ds_shipToMethod' className='gn3ds_checkout_' value='none' />
        </div>
        <div className='gn3ds_billTo'>
          <input type='hidden' id='gn3ds_billToFirstName' name='gn3ds_billToFirstName' className='gn3ds_checkout_' value={this.getFirstName()} />
          <input type='hidden' id='gn3ds_billToLastName' name='gn3ds_billToLastName' className='gn3ds_checkout_' value={this.getLastName()} />
          <input type='hidden' id='gn3ds_billToHomePhone' name='gn3ds_billToHomePhone' className='gn3ds_checkout_' value={this.getPhoneNumber()} />
          <input type='hidden' id='gn3ds_billToMobilePhone' name='gn3ds_billToMobilePhone' className='gn3ds_checkout_' value={this.getPhoneNumber()} />
          <input type='hidden' id='gn3ds_billToAddress1' name='gn3ds_billToAddress1' className='gn3ds_checkout_' value={this.props.card.address} />
          <input type='hidden' id='gn3ds_billToAddress2' name='gn3ds_billToAddress2' className='gn3ds_checkout_' value={this.props.card.complement} />
          <input type='hidden' id='gn3ds_billToAdministrativeArea' name='gn3ds_billToAdministrativeArea' className='gn3ds_checkout_' value={this.props.card.state} />
          <input type='hidden' id='gn3ds_billToCountry' name='gn3ds_billToCountry' className='gn3ds_checkout_' value='BR' />
          <input type='hidden' id='gn3ds_billToLocality' name='gn3ds_billToLocality' className='gn3ds_checkout_' value={this.props.card.city} />
          <input type='hidden' id='gn3ds_billToEmail' name='gn3ds_billToEmail' className='gn3ds_checkout_' value={this.getMail()} />
          <input type='hidden' id='gn3ds_billToPostalCode' name='gn3ds_billToPostalCode' className='gn3ds_checkout_' value={this.getZipCode()} />
        </div>
        <div className=''>
          <input type='hidden' id='gn3ds_personalId' name='gn3ds_personalId' className='gn3ds_checkout_' value={this.state.personalId} />
          <input type='hidden' id='gn3ds_personalType' name='gn3ds_personalType' className='gn3ds_checkout_' value={this.state.personalType} />
          <input type='hidden' id='gn3ds_currency' name='gn3ds_currency' className='gn3ds_checkout_' value='BRL' />
          <input type='hidden' id='gn3ds_totalAmount' name='gn3ds_totalAmount' className='gn3ds_checkout_' value={this.props.totalAmount} />

          {/*<input type='hidden' id='gn3ds_item_1_totalAmount' name='gn3ds_item_1_totalAmount' className='gn3ds_checkout_' value='1000' />*/}
          {/*<input type='hidden' id='gn3ds_item_1_unitPrice' name='gn3ds_item_1_unitPrice' className='gn3ds_checkout_' value='1' />*/}
          {/*<input type='hidden' id='gn3ds_item_1_quantity' name='gn3ds_item_1_quantity' className='gn3ds_checkout_' value='1' />*/}
          {/*<input type='hidden' id='gn3ds_item_1_sku' name='gn3ds_item_1_sku' className='gn3ds_checkout_' value='Eletrônicos' />*/}
          {/*<input type='hidden' id='gn3ds_item_1_description' name='gn3ds_item_1_description' className='gn3ds_checkout_' value='Smartphone XYZ' />*/}
          {/*<input type='hidden' id='gn3ds_item_1_name' name='gn3ds_item_1_name' className='gn3ds_checkout_' value='Smartphone XYZ' />*/}

        </div>  
        <div className='gn3ds_BrowseData'>
          <input type='hidden' id='gn3ds_httpAcceptBrowserValue' name='gn3ds_httpAcceptBrowserValue' className='gn3ds_checkout_' value='application/json' />
          <input type='hidden' id='gn3ds_httpBrowserColorDepth' name='gn3ds_httpBrowserColorDepth' className='gn3ds_checkout_' value={window.screen.colorDepth} />
          <input type='hidden' id='gn3ds_httpBrowserJavaEnabled' name='gn3ds_httpBrowserJavaEnabled' className='gn3ds_checkout_' value={window.navigator.javaEnabled() ? 'Y' : 'N'} />
          <input type='hidden' id='gn3ds_httpBrowserJavaScriptEnabled' name='gn3ds_httpBrowserJavaScriptEnabled' className='gn3ds_checkout_' value='Y' />
          <input type='hidden' id='gn3ds_httpBrowserLanguage' name='gn3ds_httpBrowserLanguage' className='gn3ds_checkout_' value={window.navigator.language} />
          <input type='hidden' id='gn3ds_httpBrowserScreenHeight' name='gn3ds_httpBrowserScreenHeight' className='gn3ds_checkout_' value={window.screen.height} />
          <input type='hidden' id='gn3ds_httpBrowserScreenWidth' name='gn3ds_httpBrowserScreenWidth' className='gn3ds_checkout_' value={window.screen.width} />
          <input type='hidden' id='gn3ds_httpBrowserTimeDifference' name='gn3ds_httpBrowserTimeDifference' className='gn3ds_checkout_' value={new Date().getTimezoneOffset()} />
          <input type='hidden' id='gn3ds_userAgentBrowserValue' name='gn3ds_userAgentBrowserValue' className='gn3ds_checkout_' value={window.navigator.userAgent} />
        </div>
        <div className='gn3ds_ExtraData'>
          <input type='hidden' id='gn3ds_startRequest' name='gn3ds_startRequest' className='gn3ds_checkout_' value={this.props.requestBinInfo} />
        </div>

        {/* Modal de autorização do banco */}
        <div className="modal fade" id="bankAuthorizationModal" tabIndex="-1" role="dialog" 
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '450px' }}>
            <div className="modal-content" style={{ border: 'none', borderRadius: '10px' }}>
              <div className="modal-body text-center p-4">
                <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: '#f0ad4e', fontSize: '28px' }} /><p style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>Autorize o pagamento no aplicativo do seu banco para finalizar sua compra.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Modal aviso tempo autenticação 3DS esgotado */}
        <div className="modal fade" id="tdsTimeoutModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document" style={{ height: '100%', display: 'flex', justifyContent: 'center' }}>
            <div className="modal-content modal-content-erro">
              <div className="modal-body modal-body-erro text-center">
                <span style={{ fontSize: '40px' }} className="text-danger">
                  <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: '#f0ad4e', fontSize: '28px' }} />
                </span>
                  
                <h3 className="modal-erro-tittle">Atenção</h3>
                <div className="modal-erro-cards">
                  <p>Tempo para responder a validação de segurança encerrado.</p>
                  <p>Caso você não tenha recebido nenhuma solicitação de validação de segurança, entre em contato com o seu banco para autorizar o pagamento.</p>
                </div>
              </div>
              <div className="modal-button-footer">
                <button id='button-close-modal-tds-timeout' type="button" className="btn btn-step" data-dismiss="modal">FECHAR</button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}